import { render, staticRenderFns } from "./ModalComplaintGroup.vue?vue&type=template&id=0763affc&"
import script from "./ModalComplaintGroup.vue?vue&type=script&lang=js&"
export * from "./ModalComplaintGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports